import React, { useMemo } from 'react';

import classnames from 'classnames';

import { useMediaQuery } from '@mui/material';

import Image, { TRANSFORMATIONS } from 'components/uiLibrary/Image';

import GallerySpaceFiller from 'components/Globals/Media/GallerySpaceFiller';

import { getProductionTitle } from 'utils/productions';

import classes from './Poster.module.scss';

const Poster = ({ production, styles, height, width, hidePoster }) => {
  const isSmallScreen = useMediaQuery('(max-width: 1100px)');
  const poster = production?.poster?.file?.urls?.medium;
  const productionTitle = useMemo(() => production?.metaInfo?.title || getProductionTitle(production), [production]);

  if (hidePoster && !poster) {
    return null;
  }

  return (
    <div className={classnames(classes.poster, { [styles?.poster]: !!styles?.poster })}>
      {poster ? (
        <Image
          src={poster}
          blurHash={poster?.blurHash}
          transformations={TRANSFORMATIONS.SLUG_POSTER}
          disableNextImage
          alt={productionTitle}
          height={height || (isSmallScreen ? 78 : 100)}
          width={width || (isSmallScreen ? 55 : 70)}
        />
      ) : (
        <GallerySpaceFiller
          text={productionTitle}
          transformations={TRANSFORMATIONS.SLUG_POSTER}
          height={height || (isSmallScreen ? 78 : 100)}
          width={width || (isSmallScreen ? 55 : 70)}
        />
      )}
    </div>
  );
};

export default Poster;
